import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@koyomi/ui';

/** Confirmação simples antes de uma ação que não dá para desfazer (avisar a cliente, marcar falta, remover da fila). */
export function ConfirmModal({ title, children, confirmLabel, danger, busy, onClose, onConfirm }: { title: ReactNode; children?: ReactNode; confirmLabel?: ReactNode; danger?: boolean; busy?: boolean; onClose: () => void; onConfirm: () => void }) {
  const { t } = useTranslation(['common']);
  return (
    <Modal open onClose={onClose} title={title} size="sm" footer={<><Button onClick={onClose} disabled={busy}>{t('common:actions.back')}</Button><Button variant={danger ? 'danger' : 'primary'} loading={busy} disabled={busy} onClick={onConfirm}>{confirmLabel ?? t('common:actions.confirm')}</Button></>}>
      {children && <p style={{ margin: 0 }}>{children}</p>}
    </Modal>
  );
}
